import Impression from "./Impression";
export default Impression;